export enum ProtocolName {
  ONE_INCH = '1inch',
  // ADD HERE PROTOCOLS NAMES
}

export const SupportedReferrer = {
  [ProtocolName.ONE_INCH]: true,
  // ADD HERE PROTOCOLS NAMES
};
